import React from "react";
import {FaTrashAlt} from "react-icons/fa";
import {FaTrash} from "react-icons/fa6";

export default function DeleteModal({ visible, onCancel, onDelete }) {
    if (!visible) return null;

    return (
        <div id="delete-modal" className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl p-6 max-w-sm w-full transform scale-100 opacity-100 transition-all duration-300" id="delete-modal-content">
                <div className="text-center">
                    <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="fa-solid fa-trash text-red-500 text-2xl">
                            <FaTrash />
                        </i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Delete Package</h3>
                    <p className="text-gray-600 mb-6">Are you sure you want to delete this package and all its signals? This action cannot be undone.</p>
                    <div className="flex space-x-3">
                        <button onClick={onCancel} className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-xl font-medium hover:bg-gray-200 transition-colors">Cancel</button>
                        <button onClick={onDelete} className="flex-1 px-4 py-3 bg-red-500 text-white rounded-xl font-medium hover:bg-red-600 transition-colors">Delete</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
